import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'svg-icon',
  templateUrl: './svg-icon.component.html',
  encapsulation: ViewEncapsulation.None
})
export class SvgIconComponent {
  @Input()
  public icon: string;
}
